<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Ürüne Seri Numarası Ekle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <form action="#">
      <label>Seri No</label>
      <div class="form-group">
        <input type="text" id="seriNo" name="seriNo" [(ngModel)]="seriNo"
          placeholder="Eklemek istediğiniz seri no giriniz." class="form-control" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()" rippleEffect>
      İptal
    </button>
    <button type="button" class="btn btn-warning" rippleEffect (click)="createProductSerial(seriNo)">
      Ekle
    </button>
  </div>